export default {
  title: 'Informații legale',
  subtitle: 'Apar în subsolul magazinului tău online și al site-ului doar după ce le salvezi.',
  card_title: 'Informații legale',
  placeholder: 'Introdu informațiile legale',
  status: {
    saved: 'Salvat',
    not_shown: 'Nu apar încă în magazin sau pe site',
    unsaved: 'Modificări nesalvate — magazinul și site-ul afișează ultima versiune salvată',
  },
  save: 'Salvează',
  retry: 'Încearcă din nou',
  preview: {
    title: 'Previzualizarea subsolului (magazin și site)',
    terms: 'Termeni',
    privacy: 'Confidențialitate',
    cookies: 'Cookie-uri',
    imprint: 'Informații legale',
  },
  toasts: {
    saved: 'Informațiile legale au fost salvate',
    save_failed: 'Informațiile legale nu au putut fi salvate. Încearcă din nou.',
    load_failed: 'Informațiile legale nu au putut fi încărcate. Reîncarcă pagina.',
  },
};
